export const getOrders = (state) => state.orders
export const getSidebarOpened = (state) => state.sidebar_opened
